<template>
  <v-container>
    <material-card
      :title="Item.title"
      :text="Item.subTitle"
      color="green"> 
      <v-form
      ref="form"
      v-model="valid"
      lazy-validation>
        <v-container py-0>
          <v-layout wrap>
            <v-flex  :class="[Item.width]">
              <v-text-field type="text"
                label="Title"
                class="green-input"
                 v-model="script.title"
                  prepend-icon='text_fields'
                 :rules="titleRule"/>
                 
            </v-flex>
            <v-flex  :class="[Item.width]">
              <v-text-field type="text"
                label="Title (Bangla)"
                class="green-input"
                 v-model="script.title_bn"
                  prepend-icon='text_fields'
                 :rules="titleBnRule"/>
                 
            </v-flex>
            <v-flex  :class="[Item.width]">
            <v-text-field label="Script file" @click='pickFile' v-model="scriptFileName" prepend-icon='attach_file' class="green-input"></v-text-field>
              <input
                type="file"
                style="display: none"
                ref="file"
                @change="onFilePicked"
                    :rules="fileRule"
              >
            </v-flex>
              
            <v-flex
              xs12
              text-xs-right>
              <v-btn
                class="mx-0 font-weight-light"
                color="success" @click="onClickButton">{{ Item.submitText }}</v-btn>
            </v-flex> 
          </v-layout>
        </v-container>
      </v-form>
    </material-card>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex"
export default {
  props: {
    // title: String,
    Item: Object,
    Value: Object
  },
  data () {
      return {
          valid: true,
          script: {},
          scriptFileName: '',
          titleRule: [
            v => !!v || 'Title is required.'
          ],
          titleBnRule :[
            v => !!v || 'Title Bangla is required.'
          ],
          fileRule: [
            v => !!v || 'File is required.'
          ],
          
      
      }
  },
  computed: {
    ...mapState("course_subjects", [
      "question"
    ])
  },
  created () {
    this.script = {}
    this.script = this.Value
  },
  methods: {
     pickFile () {
            this.$refs.file.click ()
     },
	  onFilePicked (e) {
      this.scriptFileName = e.target.files[0].name
   },
    onClickButton (event) {
        this.script.course_id = this.question.course_id ? this.question.course_id : this.Value.course_id
        this.script.subject_id = this.question.subject_id ? this.question.subject_id : this.Value.subject_id
        this.script.chapter_id = this.question.chapter_id ? this.question.chapter_id : this.Value.chapter_id
        this.script.lecture_id = this.question.lecture_id ? this.question.lecture_id : this.Value.lecture_id
      
    let file = this.$refs.file.files[0]
        if (this.$refs.form.validate()) {
          this.script.status = 'Available'
          var formData = new FormData();
          formData.append('data', JSON.stringify(this.script))
          formData.append('file', file);
  
          this.$emit('emitted', formData)
        } else {
          console.log('Second')
        }
    }
  }
}
</script>
